import React from "react";
import { Box, Card, Tabs as TabsPrimitive } from "@radix-ui/themes";

interface TabsProps {
  items: {
    key: string;
    label: string;
    content: React.ReactNode;
    hidden?: boolean;
  }[];
  selectedTab?: string;
  plain?: boolean;
}

const WrapContent = ({
  children,
  plain,
}: {
  children: React.ReactNode;
  plain?: boolean;
}) => {
  if (plain) {
    return children;
  }
  return (
    <Card>
      <Box p="3">{children}</Box>
    </Card>
  );
};

const Tabs = ({ items, selectedTab, plain }: TabsProps) => {
  return (
    <TabsPrimitive.Root
      defaultValue={selectedTab ?? items[0].key}
      style={{ flexGrow: 1 }}
    >
      <TabsPrimitive.List>
        {items
          .filter((item) => !item.hidden)
          .map((item) => (
            <TabsPrimitive.Trigger key={item.key} value={item.key}>
              {item.label}
            </TabsPrimitive.Trigger>
          ))}
      </TabsPrimitive.List>

      <Box pt="3">
        {items
          .filter((item) => !item.hidden)
          .map((item) => (
            <TabsPrimitive.Content key={item.key} value={item.key}>
              <WrapContent plain={plain}>{item.content}</WrapContent>
            </TabsPrimitive.Content>
          ))}
      </Box>
    </TabsPrimitive.Root>
  );
};

export default Tabs;
